import React, { useState } from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { useAppDispatch } from "lib/store"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"

import ALL_PAYMENT_PROVIDERS from "graphql/queries/config/AllPaymentProviders"

import PageHeader from "components/Ui/Page/PageHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import CreateKustomConfig from "./CreateKustomConfig"
import { KustomCheckoutConfigTable } from "components/Config/KustomCheckout/KustomCheckoutConfigTable"
import EditKustomConfig from "./EditKustomConfig"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { ReactComponent as KustomLogo } from "images/providers/kustom-logo.svg"
import { WithAuth } from "../../../../components/Auth"
import { PermissionGroups } from "../../../../routes/constants"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const PageKustomLogo = styled(KustomLogo)`
  height: 5rem;
`

export const KustomConfig = () => {
  const [editId, setEditId] = useState<string>("")
  const { loading, data, refetch, error } = useQuery(ALL_PAYMENT_PROVIDERS)
  const paymentProviders = data?.getPaymentProviders
  const dispatch = useAppDispatch()

  return (
    <Container>
      <PageHeader
        title={<PageKustomLogo />}
        description={<>Handle your Kustom configurations</>}
        goBackLinkText="Back to providers"
        goBackLinkUrl={"/settings/providers"}
      >
        <WithAuth requiredGroups={PermissionGroups.providers.write}>
          <PrimaryButton type="button" handleClick={() => dispatch(showEditSidebar())}>
            <PlusIcon /> Add new configuration
          </PrimaryButton>
        </WithAuth>
      </PageHeader>
      {!editId && <CreateKustomConfig refetch={refetch} />}
      {editId && <EditKustomConfig refetch={refetch} editId={editId} setEditId={setEditId} />}
      <KustomCheckoutConfigTable
        providers={paymentProviders}
        error={error}
        setEditId={setEditId}
        loading={loading}
      />
    </Container>
  )
}
